//课程管理相关 api
import request from '@/api/request'
import axios from 'axios'


// 详细信息
export function detailUnitApi(id:string) {
    let url = '/api/manager/export/classunit';
    
    let data = {
        "id":id
    }

    return request({
        url: url,
        method: 'post',
        data,
        timeout: 0        
    })
}

// 检查
export function checkUnitApi(id:string) {
    let url = '/api/manager/export/classunit/check';
    
    let data = {
        "id":id
    }

    return request({
        url: url,
        method: 'post',
        data
    })
}



// 详细信息
export function exportUnitApi(data:any) {
    let url = '/api/manager/export/classunit/export';
    
    
    
    return axios({
        url:  url,
        method: 'post',
        data,
        responseType: 'blob',
        withCredentials: true,
        timeout: 30 * 1000 // 默认最长时间30秒
    })

}

export function updateUnitApi(id:string) {
    let url = '/api/manager/export/classunit/update';
    
    let data = {
        "id":id
    }

    return request({
        url: url,
        method: 'post',
        data
    })
}









export function detailPartyOrgApi(id:string) {
    let url = '/api/manager/export/partyorg';
    
    
    
    let data = {
        "id":id
    }

    return request({
        url: url,
        method: 'post',
        data
    })
}

// 详细信息
export function exportPartyOrgApi(data:any) {
    let url = '/api/manager/export/partyorg/export';
        
    
    return axios({
        url: url,
        method: 'post',
        data,
        responseType: 'blob',
        withCredentials: true,
        timeout: 30 * 1000 // 默认最长时间30秒
    })

}



// 详细信息
export function exportApi(data:any,url:any) {    
    
    return axios({
        url:  url,
        method: 'post',
        data,
        responseType: 'blob',
        withCredentials: true,
        timeout: 60 * 60 * 1 * 1000 // 默认最长时间30秒
    })

}


/**
 * 
 * @param uids : 用户id
 * @param classes  ：  学习班id
 * @returns 
 */
export function exportByUserAndStudyClass(uids:any,classIds:any) {
    let url = '/api/manager/export/user-studyclass';
    
    let data = {
        uids,
        classIds
    }
    
    return axios({
        url:  url,
        method: 'post',
        data,
        responseType: 'blob',
        withCredentials: true,
        timeout: 30 * 1000 // 默认最长时间30秒
    })

}

/**
 * 
 * @param uids : 用户id
 * @returns 
 */
export function exportByUserAndStudyClassDangxiao(uids:any) {
    let url = '/api/manager/export/user-studyclass/dangxiao';
    
    let data = {
        uids
    }
    
    return axios({
        url:  url,
        method: 'post',
        data,
        responseType: 'blob',
        withCredentials: true,
        timeout: 30 * 1000 // 默认最长时间30秒
    })

}




export function importUidsApi(uids:any) {
    let url = '/api/manager/export/import-uid';
    
    let data = {
        uids
    }

    return request({
        url: url,
        method: 'post',
        data
    })
}

export function importSidsApi(sids:any) {
    let url = '/api/manager/export/import-sid';
    
    let data = {
        sids
    }

    return request({
        url: url,
        method: 'post',
        data
    })
}

export function importScidsApi(scids:any) {
    let url = '/api/manager/export/import-scid';
    
    let data = {
        scids
    }

    return request({
        url: url,
        method: 'post',
        data
    })
}